import { whyChooseContent } from "@/mocks/content";

export default function WhyChooseSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold uppercase tracking-wider mb-4">
            Why Choose Us
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-900 mb-3">
            {whyChooseContent.title}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Our spreadsheet platform is designed to make product research faster, smarter, and more organized than ever before.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {whyChooseContent.cards.map((card, i) => (
            <div
              key={i}
              className="group p-6 md:p-7 rounded-2xl bg-background-100 border border-background-200/60 hover:border-primary-200 transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-xl bg-accent-100 flex items-center justify-center mb-5 group-hover:bg-primary-100 transition-colors">
                <i className={`${card.icon} text-xl md:text-2xl text-accent-600 group-hover:text-primary-600 transition-colors`}></i>
              </div>
              <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-2.5">
                {card.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {card.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}